import { Button, Grid, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { withLang } from '../util/lang';
import frontend_config from '../frontend_config';
import { FaFacebookSquare } from 'react-icons/fa';
import { IoLogoInstagram } from 'react-icons/io';
import { getWebAbsPath } from '../util/path';
import buildVersion from '../buildVersion.json';

const hostname = window.location.hostname;
const styles = (theme) => ({
    footer: {
        background: frontend_config?.[hostname]?.main_background_color,
        color: 'white',
        textAlign: 'center',
        padding: 16,
    },
    footerTitle: {
        margin: '8px 0px',
        fontFamily: "'Quicksand', sans-serif",
    },
    roundBtn: {
        color: 'white',
        padding: '4px 16px',
    },
    logo: {
        width: 148,
        [theme.breakpoints.down('sm')]: {
            width: 148,
            height: 'auto',
            padding: '10px 0px',
        },
    },
    footerP: {
        color: 'white',
    },
});

class Footer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pages: [
                {
                    name: 'Home',
                    icon: '',
                    linkTo: '/',
                },
                {
                    name: 'About Us',
                    icon: '',
                    linkTo: '/',
                },
                {
                    name: 'News',
                    icon: '',
                    linkTo: '/',
                },
                {
                    name: 'Contact Us',
                    icon: '',
                    linkTo: '/',
                },
            ],
        };
    }

    returnPages() {
        return this.state.pages.map((v) => {
            return (
                <Link to={v.linkTo} key={v.name} style={{ padding: '10px 0px' }}>
                    <Button>{v.name}</Button>
                </Link>
            );
        });
    }

    render() {
        const { classes, style } = this.props;
        return (
            <div className={classes.footer} style={style}>
                <Grid container>
                    <Grid item xs={12} md={6} style={{ padding: '16px' }}>
                        <Typography variant="h5" className={classes.footerTitle}>
                            {this.get('followUs')}
                        </Typography>

                        {['CN'].includes(process.env.REACT_APP_ENV) ? (
                            <div>
                                <a
                                    target="_blank"
                                    href={localStorage.getItem('weibo_link')}
                                    style={{ textDecoration: 'unset' }}
                                    rel="noreferrer"
                                >
                                    <Button
                                        style={{
                                            margin: '6px',
                                            fontSize: 18,
                                            fontWeight: 600,
                                        }}
                                        className={classes.roundBtn}
                                    >
                                        <img
                                            src={getWebAbsPath(`./img/${localStorage.getItem('weibo_icon')}`)}
                                            style={{ width: '30px' }}
                                        ></img>
                                        {this.get('weibo')}
                                    </Button>
                                </a>

                                <a
                                    target="_blank"
                                    href={localStorage.getItem('wechat_link')}
                                    style={{ textDecoration: 'unset' }}
                                    rel="noreferrer"
                                >
                                    <Button
                                        style={{
                                            margin: '6px',
                                            fontSize: 18,
                                            fontWeight: 600,
                                        }}
                                        className={classes.roundBtn}
                                    >
                                        <div>
                                            <div>{this.get('trioclear_cn_name')}</div>
                                            <div>{this.get('wechat')}</div>
                                        </div>
                                        <img
                                            src={getWebAbsPath(`./img/${localStorage.getItem('wechat_icon')}`)}
                                            style={{ width: '120px' }}
                                        ></img>
                                    </Button>
                                </a>
                            </div>
                        ) : (
                            <div>
                                <a
                                    target="_blank"
                                    href={localStorage.getItem('facebook')}
                                    style={{ textDecoration: 'unset' }}
                                    rel="noreferrer"
                                >
                                    <Button
                                        style={{
                                            margin: '6px',
                                            fontSize: 18,
                                            fontWeight: 600,
                                        }}
                                        className={classes.roundBtn}
                                    >
                                        <FaFacebookSquare style={{ marginRight: 8, fontSize: 24 }} />

                                        {this.get('facebook')}
                                    </Button>
                                </a>
                                <a
                                    target="_blank"
                                    href={localStorage.getItem('instagram')}
                                    style={{ textDecoration: 'unset' }}
                                    rel="noreferrer"
                                >
                                    <Button
                                        style={{
                                            margin: '6px',
                                            fontSize: 18,
                                            fontWeight: 600,
                                        }}
                                        className={classes.roundBtn}
                                    >
                                        <IoLogoInstagram style={{ marginRight: 8, fontSize: 24 }} />

                                        {this.get('instagram')}
                                    </Button>
                                </a>
                            </div>
                        )}
                    </Grid>

                    {frontend_config?.[hostname] !== 'pro.qjsmlie.com' ? (
                        <Grid item xs={12} md={5} style={{ padding: '16px', textAlign: 'center' }}>
                            <Typography variant="h5" className={classes.footerTitle}>
                                {this.get('customerService').replace('cs@trioclear.com', localStorage.getItem('email'))}
                            </Typography>
                            <Typography
                                variant="body1"
                                className={classes.footerP}
                                style={{ fontFamily: "'Quicksand', sans-serif" }}
                            >
                                {localStorage.getItem('contact_us')}
                            </Typography>
                        </Grid>
                    ) : (
                        <Grid item xs={12} md={5} style={{ padding: '16px', textAlign: 'center' }}>
                            <Typography variant="h5" className={classes.footerTitle}>
                                联系我们
                            </Typography>
                            <Typography
                                variant="body1"
                                className={classes.footerP}
                                style={{ fontFamily: "'Quicksand', sans-serif" }}
                            >
                                邮箱:
                            </Typography>
                            <Typography
                                variant="body1"
                                className={classes.footerP}
                                style={{ fontFamily: "'Quicksand', sans-serif" }}
                            >
                                官网:
                            </Typography>
                            <Typography
                                variant="body1"
                                className={classes.footerP}
                                style={{ fontFamily: "'Quicksand', sans-serif" }}
                            >
                                电话:
                            </Typography>
                        </Grid>
                    )}
                </Grid>

                <Grid container>
                    <Grid item xs={12} align="center">
                        <p className={classes.footerP} style={{ fontSize: '12px' }}>
                            © {new Date().getFullYear()} {this.get('companyName')}<span> </span>{this.get('allRightsReserved')}
                        </p>
                    </Grid>
                </Grid>

                <Grid container>
                    <Grid item xs={12} align="center">
                        <p className={classes.footerP} style={{ fontSize: '10px' }}>
                            <a
                                href="https://www.trioclear.com/terms-and-conditions"
                                target="_blank"
                                style={{ textDecoration: 'none', color: 'white' }}
                                rel="noreferrer"
                            >
                                {this.get('termsAndConditions')}
                            </a>
                            <span >&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</span>
                            <a
                                href="https://www.trioclear.com/privacy-policy"
                                target="_blank"
                                style={{ textDecoration: 'none', color: 'white' }}
                                rel="noreferrer"
                            >
                                {this.get('privacyPolicy')}
                            </a>
                            <br />
                        </p>
                        <p className={classes.footerP} style={{ fontSize: '12px' }} id="versionInfo">
                            v {buildVersion.version}
                        </p>
                        {['CN'].includes(process.env.REACT_APP_ENV) && (
                            <p className={classes.footerP} style={{ fontSize: '12px' }}>
                                <a
                                    href="https://beian.miit.gov.cn"
                                    target="_blank"
                                    style={{ textDecoration: 'none', color: 'white' }}
                                    rel="noreferrer"
                                >
                                    粤ICP备2022088843号-1
                                </a>
                            </p>
                        )}
                    </Grid>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (store) => {
    return {
        lang: store.lang,
    };
};

export default connect(mapStateToProps)(withStyles(styles)(withRouter(withLang(Footer, 'Footer'))));
